import { useEffect, useMemo, useState } from 'react';
import { useStyles } from 'components/Styles';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { setDisable } from '../redux/disable';
import { setLoading } from '../redux/loading';
import Success from '../components/Snack/Success';
import Error from '../components/Snack/Error';
import api from 'services/api';

export function usePhysicalPond() {
  const classes = useStyles();
  const [showAlertDialog, setShowAlertDialog] = useState(false);
  const [ponds, setPonds] = useState([]);
  const [isPondWithSameName, setIsPondWithSameName] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const [cycles, setCycles] = useState(null);
  const [isInCycle, setIsInCycle] = useState(false);
  const [recoverPond, setRecoverPond] = useState({});

  const disable = useSelector((state) => state.disable.disable);

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { id } = useParams();
  const error = Error();
  const success = Success();

  const checkIfcopy = useMemo(() => !!location.state?.customData?.id, [location.state?.customData?.id]);
  const getIdByCopy = useMemo(() => location.state?.customData?.id, [location.state?.customData?.id]);
  const existsId = id || getIdByCopy;

  useEffect(() => {
    async function load() {
      try {
        setOpenProgress(true);
        const { data } = await api.get('/ponds/');
        setPonds(data);
      } catch (e) {
        error(e.response.data.message);
      } finally {
        setOpenProgress(false);
      }
    }
    load();
  }, []);

  useEffect(() => {
    async function getPondById() {
      try {
        setOpenProgress(true);
        const { data } = await api.get(`/ponds/${checkIfcopy ? getIdByCopy : id}`);
        setRecoverPond(data);
      } catch (e) {

      } finally {
        setOpenProgress(false);
      }
    }
    if (id || getIdByCopy) {
      getPondById();
    }
  }, [checkIfcopy, getIdByCopy, id]);

  useEffect(() => {
    if (cycles?.data) {
      cycles.data.forEach((cycle) => {
        if (cycle.pond?.id === Number(id)) setIsInCycle(true);
      });
    }
  }, [cycles, id]);

  useEffect(() => {
    async function getCycles() {
      setCycles(await api.get('cycles'));
    }
    getCycles();
  }, []);

  async function request(data) {
    dispatch(setLoading(true));
    dispatch(setDisable(true));
    try {
      if (id) {
        await api.put(`/ponds/${id}`, data[0]);
      } else {
        await api.post('/ponds', [...data]);
      }
      success();
      history.push('/ponds');
    } catch (err) {
      error(err.response.data.message);
    } finally {
      dispatch(setDisable(false));
      dispatch(setLoading(false));
    }
  }
  const handleSubmit = (values) => {
    // eslint-disable-next-line no-use-before-define
    if ((!id && isPondWithSameName) || checkPondName(values)) {
      setShowAlertDialog(true);
    } else {
      request(values.ponds);
    }
  };

  /**
   * Verifica se existe uma descrição igual dentro do array de campos
   * @param {*} values
   * @returns true ou false
   */
  const checkPondName = (values) => {
    const descriptions = new Set();

    for (let i = 0; i < values.ponds.length; i++) {
      const object = values.ponds[i];
      const { description } = object;

      if (descriptions.has(description)) {
        return true;
      }
      descriptions.add(description);
    }

    return false;
  };

  /**
   * Verifica se existe uma descrição existente dentro dos viveiros físicos já criados.
   * @param {*} values
   */
  const checkPondWithSameName = (values) => {
    let existsNameEqual = false;
    values.ponds.forEach((item) => {
      existsNameEqual = ponds?.some(({ description }) => description === item.description);
    });
    setIsPondWithSameName(existsNameEqual);
  };

  return {
    classes,
    openProgress,
    showAlertDialog,
    setShowAlertDialog,
    ponds,
    setIsPondWithSameName,
    checkPondWithSameName,
    request,
    handleSubmit,
    id,
    existsId,
    checkIfcopy,
    disable,
    isInCycle,
    recoverPond,
  };
}
